export class StringUtil {
  static toUpperCaseFirstchar = (value = "") => {
    return value
      ? value
          .split(" ")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" ")
      : "";
  };
}
